import * as pkg from '~/package.json'
import * as Sentry from '@sentry/vue'
import { getRegion } from '~/utils/locale/getDefaultLocale'

export default defineNuxtPlugin((nuxtApp) => {
  const release = `@${pkg.name}@${pkg.version}`
  const host = useRequestURL().host
  const config = useRuntimeConfig()
  const region = getRegion(host, config)
  const sentry = config.public.sentry[region] ?? config.public.sentry.default

  if (sentry.DSN) {
    Sentry.init({
      app: [nuxtApp.vueApp],
      dsn: sentry.DSN,
      release,
      environment: sentry.ENV,
      integrations: [
        Sentry.browserTracingIntegration(nuxtApp.$router),
        Sentry.replayIntegration({
          beforeErrorSampling: (error: Sentry.ErrorEvent): boolean => {
            return !!error.message?.includes('504 Gateway Timeout')
          },
        }),
      ],
      sampleRate: 0.5,
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      debug: sentry.DEBUG,
      beforeSend(event, _hint) {
        event.tags = event.tags || {}
        event.tags.integration = 'client side plugin'

        // Continue sending to Sentry
        return event
      },
      ignoreErrors: [
        'dynamically imported module',
        'module script failed',
        '_nuxt/builds/meta',
        'preload CSS',
        'XMLHttpRequestProgressEvent',
        "Can't find variable: gmo",
      ],
    })
  }
})
